import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuxModalState } from '../models/aux-modal.state';

export const auxModalStateFeatureKey = 'auxModal';

export const selectAuxModalState = createFeatureSelector<AuxModalState>(auxModalStateFeatureKey);

export const selectAuxModalConfig = createSelector(selectAuxModalState, (state) => state);
